import React, {useState} from 'react';
import { IconButton, TableCell, TableRow } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import {FullWidthTextField} from "@src/Shared/styles";

export interface IAliasNameItemFields {
    name: string;
    fullName: string;
    locked: boolean;
}

export interface IAliasNameItem {
    itemId: string;
    listId: number;
    fields?: IAliasNameItemFields;
    initial?: IAliasNameItemFields;
    touched?: boolean;
    isNew: boolean;
    errors?: any;
}

export interface IAliasNameItemProps {
    item: IAliasNameItem;
    onChange: any;
    onRemove: any;
    errors?: any;
    lockInputs?: boolean;
}

export function AliasNameItem(props: IAliasNameItemProps) {

    const [name, setName] = useState(props.item.fields.name);
    const [fullName, setFullName] = useState(props.item.fields.fullName);
    const [locked, setLocked] = useState(props.item.fields.locked);
    
    function onNameChange(ev: any) {
        setName(ev.target.value);
        props.onChange(props.item.listId, { name: ev.target.value, fullName, locked });
    }

    function onFullNameChange(ev: any) {
        setFullName(ev.target.value);
        props.onChange(props.item.listId, { name, fullName: ev.target.value, locked });
    }

    function onLockedChange(state: boolean) {
        setLocked(state);
        props.onChange(props.item.listId, { name, fullName, locked: state });
    }

    return (
        <TableRow>
            <TableCell>
                <FullWidthTextField
                    disabled={props.lockInputs}
                    error={!!props.item.errors?.name}
                    label={props.item.errors?.name}
                    value={props.item.fields.name}
                    onChange={(ev: any) => { onNameChange(ev) }}
                    placeholder={"Name"}
                    variant="outlined"
                    size={"small"}
                />
            </TableCell>
            <TableCell>
                <FullWidthTextField
                    disabled={props.lockInputs}
                    error={!!props.item.errors?.fullName}
                    label={props.item.errors?.fullName}
                    value={props.item.fields.fullName}
                    onChange={(ev: any) => { onFullNameChange(ev) }}
                    placeholder={"Full name"}
                    variant="outlined"
                    size={"small"}
                />
            </TableCell>
            { !props.lockInputs && (
                <TableCell style={{ width: 64 }} size={"small"} align={"center"}>
                    <IconButton onClick={() => { props.onRemove(props.item.listId) }}>
                        <DeleteIcon />
                    </IconButton>
                </TableCell>
            )}
        </TableRow>
    )
}

